import { render, staticRenderFns } from "./TemporaryLeave.vue?vue&type=template&id=7e36d8e4&"
import script from "./TemporaryLeave.vue?vue&type=script&lang=js&"
export * from "./TemporaryLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports